export const FILTERS_MICROFRONTEND_ALIAS = 'filters-microfrontend-alias';
